module.exports = __webpack_public_path__ + "static/media/team_h.60dd980d.png";